	import React,{Component} from "react";
	// import { withRouter } from 'react-router';
	import Wrp from '../../hoc/Wrp/Wrp';
	import $ from 'jquery';


	class SplitViewSideBarToggle extends Component {
		constructor(props) {
			super(props);
			this.state = {
				isSplitViewOpen : true,
			}
		}

		componentDidMount = ()=>{
			window.addEventListener("resize", this.updateDimensions);
			this.updateDimensions();
		}
		componentDidUpdate = (prevProps) =>{
			if(prevProps.isSplitViewOpen!==this.props.isSplitViewOpen){
				this.setState({
					isSplitViewOpen:this.props.isSplitViewOpen
				});
			}
		}

		componentWillUnmount() {
			window.removeEventListener('resize', this.updateDimensions);
		}
		toggleSplitWindow = () => {
	      this.setState({isSplitViewOpen:!this.state.isSplitViewOpen});
	    }
	    hideSidebarToggle =() => {
	        this.setState({isSplitViewOpen:false});
	    }
			
		updateDimensions = ()=>{
			if ($(window).width() < 992) {
				//$('#splitView_sidebar').addClass('active');
				this.setState({isSplitViewOpen:false});
			} else {
				//$('#splitView_sidebar').removeClass('active');
				this.setState({isSplitViewOpen:true});
			}
		}
		render(){
			const {isSplitViewOpen} = this.state;
			const {attributes,isStatic} = this.props;
			return(
				<Wrp>
					<nav id="splitView_sidebar" className={isSplitViewOpen === true ? "" : "active"}>
						<div className="toggleFolSplitView"   onClick={this.toggleSplitWindow}>
			                <a className="cursor-pointer"  id="sidebarCollapse"> 
								{/*<svg x="0px" y="0px" width="14px" height="14px" viewBox="0 0 14 14" enableBackground="new 0 0 14 14">
								  <path className="first-path" fill="none" stroke="#00FFFF" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M7.914,3.531 l3.472,3.467l-3.467,3.471"/>
								  <path className="second-path" fill="none" stroke="#00FFFF" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M4.107,2.821 l4.182,4.177l-4.176,4.181"/>
								</svg>*/}

								<svg  width="20px" height="20px" viewBox="0 0 256 256">
									<polyline fill="none" stroke="#f4734b" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24" points="56 48 136 128 56 208">
									</polyline>
									<polyline fill="none" stroke="#f4734b" opacity="0.8" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24" points="136 48 216 128 136 208">
									</polyline>
								</svg>
			                </a>
			            </div>

			            {
			            	(isStatic===false)?
			            	<div onClick={()=>this.hideSidebarToggle()} id="close-sidebar" className="animated fadeInLeft">				          								
								<span className="">
									<svg viewBox="0 0 256 256" width="20px" height="20px" className="animated fadeInRight">
										<polyline fill="none" stroke="#1a2035" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24" points="200 208 120 128 200 48">
										</polyline>
										<polyline fill="none" stroke="#1a2035" opacity="0.5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24" points="120 208 40 128 120 48">
										</polyline>
									</svg>
								</span>
					        </div>
			            	:
			            	<></>
			            }
			            
			            <div className="filter_Box dataTables_wrapper leftSidePort">
			            	{this.props.children}
			            </div>
					</nav>
				</Wrp>
			)
		}
		
	}
	SplitViewSideBarToggle.defaultProps = {
		iconStyle:{},		
		attributes:{},
		isSplitViewOpen:false,
		isStatic:false
	}

	export default SplitViewSideBarToggle;